import React, { useEffect, useState } from 'react';
import API from 'libs/api';
import { useParams } from 'react-router-dom';
import { Button } from "semantic-ui-react";
import ICON from 'components/cmp_icon/cmp_icon';
import TABLE from 'components/cmp_table/cmp_table';

import MDL_LOCATION from './mdl_location/mdl_location';

export default function TAB_LOCATIONS({ current_tab }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    //  data table variables
    const [ var_data, set_data ] = useState([]);
    const [ var_data_settings, set_data_settings ] = useState({
        limit: 15,
        offset: 0,
        totalrows: 0,
        search: '',
        sortby: 'city',
        sortorder: 'asc'
    });
    const [ var_totalrows, set_totalrows ] = useState(0);

    //  data ready variables
    const [ var_ready, set_ready ] = useState(false);
    const [ var_processing, set_processing ] = useState('inactive');

    //  modal variables
    const [var_location_open, set_location_open] = useState(false);
    const [var_locationID, set_locationID] = useState('');



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (current_tab === 'LOCATIONS' && provider_id) {
            get_locations(var_data_settings);
        }
    }, [ current_tab, provider_id ]);



    //  async functions ------------------------------------------------------------------------------------------------

    async function get_locations(data_settings){

        set_ready(false);
        set_processing('processing');

        //  use current data settings if none are submitted
        data_settings && set_data_settings(data_settings);
        let settings = data_settings || var_data_settings;

        try {
            let results = await API_get_locations(settings);

            //  set totalrows
            set_totalrows(results.totalrows);

            //  set data
            set_data(results.results === undefined ? [] : results.results);

            set_processing('inactive');
            set_ready(true);
        } catch (e) {
            set_processing('error');
        }

    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_locations(settings){
        let var_parameters = {queryStringParameters: settings};
        return API.get('admin-providers', '/get-locations/' + provider_id, var_parameters);
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_addLocation(){
        set_locationID('ADD');
        set_location_open(true);
    }

    function onClick_location(location) {
        set_locationID(location.id);
        set_location_open(true);
    }


    // RENDER CONTAINER ================================================================================================

    return (

        <div id='tab__page--provider_locations' className='tab__page tab__transition'>

            <div className='card providers'>
                <div className='card__header'>
                    <div className='card__header__title_totalrows'>
                        <div className='text--md bold'>Provider locations</div>
                        <div className='card__header__totalrows text--md normal'>{var_totalrows.toLocaleString()}</div>
                    </div>
                    <div className='card__header__options'>
                        <Button className='primary' onClick={onClick_addLocation}>Add location</Button>
                    </div>
                </div>
                <div className='card__content'>

                <TABLE
                    var_data_settings={var_data_settings}
                    set_data_settings={set_data_settings}
                    onChange={get_locations}
                    processing={var_processing}
                    totalrows={var_totalrows}
                >
                    <headers>
                        <header sortby='reviewed' width='48px'>Rev</header>
                        <header sortby='online' width='48px'>Type</header>
                        <header sortby='address'>Address</header>
                        <header sortby='city' >City</header>
                        <header sortby='state' width='112px'>Province</header>
                        <header sortby='country' width='112px'>Country</header>
                        <header sortby='lat' width='112px'>Lat</header>
                        <header sortby='lon' width='112px'>Lon</header>
                        <header sortby='geoapify_confidence' width='88px'>Confidence</header>
                        <header sortby='lastmodified' width='192px'>Modified</header>
                        <header sortby='lastmodifiedby'>Modified by</header>
                    </headers>
                    <data>
                        {var_data.map(item =>
                            <row key={item.id} onClick={()=>onClick_location(item)}>
                                <cell>
                                    {item.reviewed === 'YES' &&
                                        <div className='cell--icon green'>
                                            <ICON name='checkmark' className='icon' alt='checkmark icon'/>
                                        </div>
                                    }
                                </cell>
                                <cell>
                                    {item.online === 'YES' ?
                                        <div className='cell--icon simple'>
                                            <ICON name='wifi' className='icon' alt='wifi icon'/>
                                        </div>
                                        :
                                        item.cityonly === 'YES' &&
                                        <div className='cell--icon simple'>
                                            <ICON name='crosshair' className='icon' alt='crosshair icon'/>
                                        </div>
                                    }
                                </cell>
                                <cell>{item.address}</cell>
                                <cell>{item.city}</cell>
                                <cell>{item.state}</cell>
                                <cell>{item.country}</cell>
                                <cell>{item.lat}</cell>
                                <cell>{item.lon}</cell>
                                <cell>{item.geoapify_confidence}</cell>
                                <cell>{item.lastmodified}</cell>
                                <cell>{item.lastmodifiedby}</cell>
                            </row>
                        )}
                    </data>
                </TABLE>

                </div>
            </div>

            <MDL_LOCATION
                onOpen={var_location_open}
                onClose={() => set_location_open(false)}
                onRefresh={get_locations}
                var_locationID={var_locationID}
                var_providerID={provider_id}
            />

        </div>
    );
}
